// import React from "react";
// import MastheadZerto from "../components/sections/homepage/MastheadZerto";
// import Empower from "../components/sections/homepage/Empower";
// import Advantage from "../components/sections/homepage/Advantage";
// import Features from "../components/sections/homepage/Features";
// import Solution from "../components/sections/homepage/Solution";
// import Layout from "../components/layout/Layout";
// import CtaSection from "../components/sections/homepage/CtaSection";
// import CarouselPage from "./CarouselPage";
import { useExperiment } from "@statsig/react-bindings";
import ZertoOne from "./ZertoOne";
import ZertoTwo from "./ZertoTwo";

export const HomepageZerto = () => {
  const { value } = useExperiment("zerto_template_test");
  const variant = value?.template ?? "template-a";

  return variant === "template-a" ? <ZertoOne /> : <ZertoTwo />;
  // return (
  //   <Layout title="HPE Zerto Software">
  //     <MastheadZerto />
  //     {/* <CarouselPage /> */}
  //     {/* <Empower />
  //     <Advantage />
  //     <CtaSection />
  //     <Features />
  //     <Solution /> */}
  //   </Layout>
  // );
};
